import React from 'react';
import { motion } from 'framer-motion';
import Dashboard from './Dashboard';

const HeroSection = () => {
  const triggerModal = () => {
    window.dispatchEvent(new Event('openModal'));
  };

  return (
    <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-32 overflow-hidden border-b border-gray-800 animate-glow-border gradient-loop-bg">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:w-1/2 text-center lg:text-left"
          >
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="inline-flex items-center gap-2 bg-gray-900/80 backdrop-blur-sm border border-gray-700 rounded-full px-4 py-1 mb-6"
            >
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
              <span className="text-xs font-medium text-gray-300 uppercase tracking-widest">
                2026 Career Blueprint 🚀
              </span>
            </motion.div>

            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-white"
            >
              How to Secure a <span className="text-pbi-yellow">$95k+ Data Analyst Role</span> in Just <span className="text-pbi-yellow">90 Days</span>
            </motion.h1>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="text-gray-200 text-xl md:text-2xl font-semibold mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0"
            >
              Master Power BI <span className="text-pbi-yellow underline decoration-2 underline-offset-4">without writing a single line of code</span>—even if your H1B clock is ticking and you're currently stuck in a "survival job."
            </motion.div>

            <motion.button 
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.98 }}
              className="w-full md:w-auto bg-green-600 hover:bg-green-500 text-white text-xl font-bold px-12 py-5 rounded-xl shadow-[0_0_20px_rgba(34,197,94,0.4)] transition-all duration-300 flex items-center justify-center gap-4 border border-green-400/20"
              onClick={triggerModal}
            >
              <i className="fa-solid fa-download animate-bounce"></i>
              Get Free Roadmap Today
            </motion.button>

            <p className="mt-4 text-gray-500 text-sm italic">
              *Limited time offer: Free download for the next 24 hours
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="lg:w-1/2 w-full perspective-1000"
          >
            <div className="animated-border-box">
              <div className="animated-border-content">
                <Dashboard />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;